/**
 * Sélecteur Pays (marché/devise) + Langue en modale.
 * Le <select> + bouton "Continuer" soumettent le form natif Shopify
 * {% form 'localization' %} (country_code + language_code) : Shopify gère
 * le changement de marché/devise et la redirection de domaine.
 *
 * Ce composant gère : ouverture/fermeture de la modale + mise à jour des
 * langues disponibles selon le pays sélectionné (sans reload).
 */
class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.modal = this.querySelector('[data-mls-modal]');
		this.countrySelect = this.querySelector('select[name="country_code"]');
		this.languageSelect = this.querySelector('select[name="language_code"]');
		this._onKey = (e) => {
			if (e.key === 'Escape') this.close();
		};

		this.querySelectorAll('[data-mls-open]').forEach((btn) =>
			btn.addEventListener('click', () => this.open())
		);
		this.querySelectorAll('[data-mls-close]').forEach((btn) =>
			btn.addEventListener('click', () => this.close())
		);

		// MAJ des langues quand on change de pays
		if (this.countrySelect && this.languageSelect) {
			this.countrySelect.addEventListener('change', () => this.updateLanguages());
		}
	}

	/**
	 * Map pays -> langues, partagee par toutes les instances (snippet mm-language-map,
	 * rendu une seule fois en fin de <body>). Parsee a la demande, une seule fois.
	 */
	static getLangMap() {
		if (!LocalizationForm._langMap) {
			const mapEl = document.querySelector('[data-mls-langmap]');
			try {
				LocalizationForm._langMap = mapEl ? JSON.parse(mapEl.textContent) : {};
			} catch (e) {
				LocalizationForm._langMap = {};
			}
		}
		return LocalizationForm._langMap;
	}

	updateLanguages() {
		const langs = LocalizationForm.getLangMap()[this.countrySelect.value];
		if (!langs || !langs.length) return;

		// Conserver la langue courante si elle reste disponible, sinon la 1ère
		const current = this.languageSelect.value;
		const keep = langs.some((l) => l.iso === current) ? current : langs[0].iso;

		this.languageSelect.innerHTML = '';
		langs.forEach((l) => {
			const opt = document.createElement('option');
			opt.value = l.iso;
			opt.textContent = l.label;
			if (l.iso === keep) opt.selected = true;
			this.languageSelect.appendChild(opt);
		});
	}

	open() {
		if (!this.modal) return;
		this.modal.hidden = false;
		document.documentElement.classList.add('mm-mls-lock');
		document.addEventListener('keydown', this._onKey);
		this.modal.querySelector('select')?.focus();
	}

	close() {
		if (!this.modal) return;
		this.modal.hidden = true;
		document.documentElement.classList.remove('mm-mls-lock');
		document.removeEventListener('keydown', this._onKey);
	}
}

customElements.define('localization-form', LocalizationForm);
